/**
 * Высота строки гридов приложения — то же значение, что задано всем гридам глобально
 * (`buildKitSettings` → `DataGrid.rowHeight`).
 */
const GRID_ROW_HEIGHT = 36;

/** Высота обвязки `DataGrid` поверх строк: шапка таблицы, футер со счётчиком строк и отступы. */
const GRID_CHROME_HEIGHT = 96;

/**
 * Высота `DataGrid`, который тянется по своим строкам, но не выше заданного потолка.
 * Без потолка грид показывает все свои строки: собственной прокрутки у него не остаётся —
 * прокручивается то, что его содержит.
 *
 * Своей высоты «по содержимому» у грида нет: он виртуализирован и занимает высоту контейнера,
 * поэтому её задаёт потребитель. Не поместившееся прокручивается внутри самого грида — в том
 * числе строки с переносом текста (`wrap`), которые выше расчётной.
 */
export const dataGridHeightByRows = (rowCount: number, maxHeight?: number): number => {
  const contentHeight = rowCount * GRID_ROW_HEIGHT + GRID_CHROME_HEIGHT;

  return maxHeight === undefined ? contentHeight : Math.min(contentHeight, maxHeight);
};
